import { DeliveryData } from "@/lib/types/checkout-steps";
import { useTranslation } from "react-i18next";

interface DeliveryLocation {
  name: string;
  deliveryAddress: {
    streetName: string;
    streetNumber: string;
    city: string;
  };
}

interface DeliverySummaryProps {
  data: DeliveryData;
}

export function DeliverySummary({ data }: DeliverySummaryProps) {
  const { t } = useTranslation();
  const textClassName = "text-sm";

  if (data.deliveryMethod === "pickup" && data.address) {
    const storeLines = [
      t("delivery.options.pickup"),
      t("delivery.storeHours"),
      t("delivery.storeAddress"),
    ];

    return (
      <div className="space-y-1">
        {storeLines.map((text, index) => (
          <p key={index} className={textClassName}>
            {text}
          </p>
        ))}
      </div>
    );
  }

  const isServicePoint = data.deliveryMethod === "servicePoint";
  const location = isServicePoint
    ? data.selectedServicePoint
    : data.selectedParcelBox;

  if (!location) {
    return null;
  }

  const deliveryMethod = isServicePoint
    ? t("delivery.summaryServicePoint")
    : t("delivery.summaryParcelBox");
  const { name, deliveryAddress } = location as DeliveryLocation;
  const { streetName, streetNumber, city } = deliveryAddress;

  const formattedCity = city
    ?.toLowerCase()
    .replace(/(^|\s)[a-zåäö]/g, (letter) => letter.toUpperCase());

  const address = `${streetName} ${streetNumber}, ${formattedCity}`;

  return (
    <div>
      <p className={textClassName}>{deliveryMethod}</p>
      <p className={textClassName}>{name}</p>
      <p className={textClassName}>{address}</p>
    </div>
  );
}
